type AppEnv = 'LOCAL' | 'STAGING' | 'PRODUCTION' | 'DEMO';

const env = process.env.REACT_APP__APP_ENV as AppEnv;

export const AppConfig = {
    app: {
        port: Number(process.env.PORT),
        env,
        isLocal: env === 'LOCAL',
        isStaging: env === 'STAGING',
        isProd: env === 'PRODUCTION',
        isDemo: env === 'DEMO',
        apiUrl: process.env.REACT_APP__API_URL as string,
    },

    cookieTokenNames: {
        auth: process.env.REACT_APP__AUTH_TOKEN_NAME as string,
    },
};